/* @flow */
import React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';

import './styles/JoinSignUpPageLeftPanel.scss';

const JoinSignUpPageLeftPanel = React.createClass({
  render() {
    return (
      <div className="JoinSignUpPageLeftPanel">
        <TitleHeader
          image={require('assets/images/signup-devices.svg')}
          title="Sign up for Remind"
          subtext={`Reach students and parents where they are. Send quick, simple messages to any
            device—for free.`}
          size="xlarge"
          className="JoinSignUpPageLeftPanel-title"
        />
      </div>
    );
  },
});

export default JoinSignUpPageLeftPanel;



// WEBPACK FOOTER //
// ./src/join/components/JoinSignUpPageLeftPanel.jsx